import React from 'react'; 
import { useNavigate } from 'react-router-dom';

// Import images for each product
import bedImg from '../../../img/beds.jpeg'; 
import covesImg from '../../../img/coves1.jpeg'; 
import stopImg1 from '../../../img/Stop2.jpeg'; 
import casungImg from '../../../img/Casung1.jpeg'; 

const Products = () => {
  const navigate = useNavigate();
  const title = ' ';  // Título en español
  const products = [
    {
      id: 1,
      name: 'Beds',  // Nombre en español
      description: 'Una moldura decorativa refinada, más pequeña y menos prominente que las molduras de corona. Se utiliza para embellecer uniones o transiciones de superficie, proporcionando una apariencia suave y pulida a los elementos de diseño interior.',
      image: bedImg, // Imagen para Camas
    },
    {
      id: 2,
      name: 'Coves',  // Nombre en español
      description: 'Una moldura decorativa con forma curva o cóncava, comúnmente colocada en la unión entre el techo y la pared. Crea una transición suave y elegante y puede mejorar el flujo visual de una habitación.',
      image: covesImg, // Imagen para Cúpulas
    },
    {
      id: 3,
      name: 'Stops',  // Nombre en español
      description: 'Los topes pueden ser piezas adicionales utilizadas para terminar molduras o juntas, proporcionando una transición suave o un punto de detención visual. Actúan como un tope, asegurando que la puerta o ventana no pase más allá de cierto punto.',
      image: stopImg1, // Imagen para Topes
    },
    {
      id: 4,
      name: 'Casung',  // Nombre en español
      description: 'Moldura arquitectónica o marco que rodea puertas, ventanas u otras aberturas. Sirve tanto a fines funcionales como estéticos, agregando definición e interés visual a los elementos arquitectónicos.',
      image: casungImg, // Imagen para Casung
    }
  ];

  const handleProductClick = (category) => {
    navigate(`/products/${category.toLowerCase()}`);
  };

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-8">{title}</h1> 
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {products.map((product) => (
          <div 
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full" 
            key={product.id}
            onClick={() => handleProductClick(product.name)}
          >
            <img 
              src={product.image} 
              alt={product.name} 
              className="w-full h-48 object-cover"
            />
            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold mb-2 text-gray-800">{product.name}</h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">{product.description}</p>
            </div>
          </div>
        ))}

        {/* Informative Card */}
        <div 
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
          <div>
            <h5 className="text-xl font-bold text-emerald-50 mb-4">¿Necesitas más información?</h5>
            <p className="text-emerald-100 mb-4">
              Si deseas obtener más detalles sobre nuestros productos o tienes alguna consulta especial, 
              no dudes en contactarnos. Estamos aquí para ayudarte.
            </p>
            <p className="text-emerald-100">
              Para ver la lista completa de productos, regístrate para obtener tu token de acceso (clave).
            </p>
          </div>

          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contáctanos →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
